<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.592"
    height="14.04"
    viewBox="0 0 20.592 14.04"
    class="icon icon--eye"
  >
    <g transform="translate(0 -89.25)">
      <g transform="translate(0 89.25)">
        <path
          fill="currentColor"
          d="M10.3,89.25A11.028,11.028,0,0,0,0,96.27a11.06,11.06,0,0,0,20.592,0A11.028,11.028,0,0,0,10.3,89.25Zm0,11.7a4.68,4.68,0,1,1,4.68-4.68A4.634,4.634,0,0,1,10.3,100.95Zm0-7.488A2.808,2.808,0,1,0,13.1,96.27,2.758,2.758,0,0,0,10.3,93.462Z"
          transform="translate(0 -89.25)"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'Eye',
  };
</script>